export default "<div class=\"camera-bullet\">\n  <span [ngStyle]=\"{'border-color': color, 'background': color}\"></span>\n  {{this.title}}\n</div>\n"